<template>
  <div>
    <Row style="padding:10px 0px 0px 0px;margin-bottom: 10px">
      <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="success" @click="modal9 = true">导出CSV</Button>
      </Col>
      <Col span="3" style="padding:0px 5px 0px 0px">
        <Button long type="warning" @click="modal8 = true">检索条件</Button>
      </Col>
    </Row>
    <Table
      ref="table"
      :loading="loading"
      :height="height * 0.7"
      :width="width * 0.8"
      :columns="columns1"
      :data="data2"
    ></Table>
    <!-- 模态框 -->
    <div>
      <Modal title="Title" v-model="modal9" :mask-closable="false" width="170">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>选择导出字段</span>
        </p>
        <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
          <Checkbox
            :indeterminate="indeterminate"
            :value="checkAll"
            @click.prevent.native="handleCheckAll"
          >全选</Checkbox>
        </div>
        <div style="text-align:left">
          <CheckboxGroup v-model="checkAllGroup" class="check_grop">
            <div>
              <Row v-for="item in columns1">
                <Col span="24">
                  <Checkbox :label="item">
                    <span>{{item.title}}</span>
                  </Checkbox>
                </Col>
              </Row>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button type="info" size="large" @click="exportCSV" long>导出CSV</Button>
        </div>
      </Modal>

      <Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
        <p slot="header" style="color:#0066FF;text-align:center">
          <Icon type="md-create" />
          <span>检索条件</span>
        </p>
        <div style="text-align:center">
          <CheckboxGroup v-model="selectedCondition" class="check_grop">
            <div>
              <Row>
                <Col span="12">
                  <Checkbox label="meterBatch">
                    <span>生产批次</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Input
                    v-model="formValidate.meterBatchModel"
                    placeholder="请输入批次信息"
                    style="width: 150px"
                  />
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <Checkbox label="boardId">
                    <span>电路板号码</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Input
                    v-model="formValidate.boardIdModel"
                    placeholder="请输入电路板号码"
                    style="width: 150px"
                  />
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <Checkbox label="timeStamp">
                    <span>生产时间</span>
                  </Checkbox>
                </Col>
                <Col span="12">
                  <Tooltip placement="top" transfer>
                    <div slot="content">
                      <span>
                        {{(()=>{
                        if(formValidate.timeStampModel &&
                        formValidate.timeStampModel[0] &&
                        formValidate.timeStampModel[1] &&
                        formValidate.timeStampModel.length > 0){
                        return getTimeStampStart();
                        }else{
                        return "请选择时间区间";}
                        })()}}
                      </span>
                      <br
                        v-if="(formValidate.timeStampModel &&
                        formValidate.timeStampModel[0] &&
                        formValidate.timeStampModel[1] &&
                        formValidate.timeStampModel.length > 0)"
                      />
                      <span
                        style="margin-left:50%"
                        v-if="(formValidate.timeStampModel &&
                        formValidate.timeStampModel[0] &&
                        formValidate.timeStampModel[1] &&
                        formValidate.timeStampModel.length > 0)"
                      >~</span>
                      <br
                        v-if="(formValidate.timeStampModel &&
                        formValidate.timeStampModel[0] &&
                        formValidate.timeStampModel[1] &&
                        formValidate.timeStampModel.length > 0)"
                      />
                      <span
                        v-if="(formValidate.timeStampModel &&
                        formValidate.timeStampModel[0] &&
                        formValidate.timeStampModel[1] &&
                        formValidate.timeStampModel.length > 0)"
                      >
                        {{(()=>{
                        return getTimeStampEnd();
                        })()}}
                      </span>
                    </div>
                    <DatePicker
                      v-model="formValidate.timeStampModel"
                      type="daterange"
                      format="yyyy-MM-dd"
                      split-panels
                      placeholder="请选择时间区间"
                      style="width: 150px"
                    ></DatePicker>
                  </Tooltip>
                </Col>
              </Row>
            </div>
          </CheckboxGroup>
        </div>
        <div slot="footer">
          <Button type="info" size="large" @click="searchByCondition" long>获取数据</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
export default {
  name: "meter_export",
  mounted() {
    // this.formValidate.meterBatchModel = global.dateFtt(
    //   "yyyy-MM-dd",
    //   new Date()
    // );
    this.getInfoType();
    // this.modal8 = true;
    this.getRecord();
  },
  methods: {
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        this.checkAllGroup = this.columns1;
      } else {
        this.checkAllGroup = [];
      }
    },

    // 按条件检索点击事件
    searchByCondition() {
      this.modal8 = false;
      // this.requestBody = {};
      this.requestBody.meterBatch = null;
      this.requestBody.deviceId = null;
      this.requestBody.timeStamp = null;
      clearInterval(this.interval);
      for (var temp in this.selectedCondition) {
        if (this.selectedCondition[temp] == "meterBatch") {
          if (this.formValidate.meterBatchModel == "") {
            continue;
          }

          this.requestBody["meterBatch"] = this.formValidate.meterBatchModel;
          // requestBody.set("commandId", this.commandIdModel);
        }

        if (this.selectedCondition[temp] == "boardId") {
          if (this.formValidate.boardIdModel == "") {
            continue;
          }

          this.requestBody["deviceId"] = this.formValidate.boardIdModel;
          // requestBody.set("deviceId", this.deviceIdModel);
        }

        if (this.selectedCondition[temp] == "timeStamp") {
          if (
            this.formValidate.timeStampModel[0] == "" ||
            this.formValidate.timeStampModel[1] == ""
          ) {
            continue;
          }

          this.requestBody["timeStamp"] = this.getTimeStamp();
        }
      }

      // 调用接口查询
      this.getRecord();
    },
    getTimeStampStart() {
      return global.dateFtt(
        "yyyy-MM-dd hh:mm:ss",
        new Date(this.formValidate.timeStampModel[0])
      );
    },
    getTimeStampEnd() {
      return global.dateFtt(
        "yyyy-MM-dd hh:mm:ss",
        new Date(this.formValidate.timeStampModel[1])
      );
    },
    getTimeStamp() {
      let startYear = this.formValidate.timeStampModel[0]
        .getFullYear()
        .toString();
      let startMonth =
        this.formValidate.timeStampModel[0].getMonth() >= 9
          ? (this.formValidate.timeStampModel[0].getMonth() + 1).toString()
          : "0" + (this.formValidate.timeStampModel[0].getMonth() + 1);
      let startDate =
        this.formValidate.timeStampModel[0].getDate() >= 9
          ? this.formValidate.timeStampModel[0].getDate().toString()
          : "0" + this.formValidate.timeStampModel[0].getDate();

      let endYear = this.formValidate.timeStampModel[1]
        .getFullYear()
        .toString();
      let endMonth =
        this.formValidate.timeStampModel[1].getMonth() >= 9
          ? (this.formValidate.timeStampModel[1].getMonth() + 1).toString()
          : "0" + (this.formValidate.timeStampModel[1].getMonth() + 1);
      let endDate =
        this.formValidate.timeStampModel[1].getDate() >= 9
          ? this.formValidate.timeStampModel[1].getDate().toString()
          : "0" + this.formValidate.timeStampModel[1].getDate();

      let result =
        startYear +
        "/" +
        startMonth +
        "/" +
        startDate +
        "-" +
        endYear +
        "/" +
        endMonth +
        "/" +
        endDate;
      return result;
    },

    exportCSV() {
      this.data2.forEach(function(value, i) {
        Object.keys(value).forEach(function(key, i) {
          value[key] = "\t" + value[key];
        });
      });

      this.$refs.table.exportCsv({
        filename: "批次-基表信息",
        columns: this.columns1.filter(
          (col, index) => this.checkAllGroup.indexOf(col) >= 0
        ),
        data: this.data2
      });
    },
    setTime(e) {
      this.formValidate.meterBatchModel = e;
    },
    getInfoType() {
      let temp = {};
      temp["cnName"] = "基表信息";
      this.infoEnum["FFFF"] = temp;
    },
    getRecord() {
      var that = this;
      that.loading = true;

      var baseUrl = "/api/getProduceMeterInfoByBatch";
      var param1 = "";
      var param2 = "";
      var param3 = "";

      if (
        that.requestBody["meterBatch"] != null &&
        that.requestBody["meterBatch"] != undefined
      ) {
        param1 = "batch=" + that.requestBody["meterBatch"];
      }
      if (
        that.requestBody["deviceId"] != null &&
        that.requestBody["deviceId"] != undefined
      ) {
        param2 = "boardId=" + that.requestBody["deviceId"];
      }
      if (
        that.requestBody["timeStamp"] != null &&
        that.requestBody["timeStamp"] != undefined
      ) {
        param3 = "timeStamp=" + that.requestBody["timeStamp"];
      }

      var url = baseUrl;

      if (param1 != "") {
        if (url.indexOf("?") > 0) {
          url = url + "&" + param1;
        } else {
          url = url + "?" + param1;
        }
      }
      if (param2 != "") {
        if (url.indexOf("?") > 0) {
          url = url + "&" + param2;
        } else {
          url = url + "?" + param2;
        }
      }
      if (param3 != "") {
        if (url.indexOf("?") > 0) {
          url = url + "&" + param3;
        } else {
          url = url + "?" + param3;
        }
      }

      $.ajax({
        url: url,
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(receiveData) {
          if (
            receiveData.errorCode != undefined &&
            receiveData.errorCode != 0
          ) {
            that.$Notice.error({
              title: "异常",
              desc: receiveData.errorInfo
            });
            return;
          }

          receiveData.meterList.forEach(function(value, i) {
            if (value["meterBase"] == -1) {
              value["meterBase"] = "未更新";
            }
            if (value["boardId"] == -1) {
              value["boardId"] = "未更新";
            }

            receiveData.meterList[i] = value;
          });
          that.data2 = receiveData.meterList;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.loading = false;
        }
      });
    }
  },
  data() {
    return {
      timeStr: "",
      indeterminate: true,
      checkAll: false,
      loading: false,
      selectedCondition: [],
      checkAllGroup: [],
      infoEnum: {},
      requestBody: {
        meterBatch: null,
        deviceId: null,
        timeStamp: null
      },
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      modal8: false,
      modal9: false,
      formValidate: {
        timeStampModel: [],
        meterBatchModel: "",
        meterIdModel: "",
        infoTypeModel: "FFFF",
        meterId: ""
      },

      columns1: [
        {
          title: "基表号",
          key: "meterId",
          width: 150
        },
        {
          title: "回转系数",
          key: "rotationCoef"
        },
        {
          title: "齿轮号码",
          key: "gearId"
        },
        {
          title: "齿轮1号码",
          key: "gear1Number"
        },
        {
          title: "齿轮2号码",
          key: "gear2Number"
        },
        {
          title: "型号",
          key: "ratedFlow"
        },
        {
          title: "批次",
          key: "batch"
        },
        {
          title: "厂商",
          key: "manufacturer"
        },
        {
          title: "生产日期",
          key: "updateTime"
        },
        {
          title: "电路板号码",
          key: "boardId",
          width: 150
        },
        {
          title: "表底数",
          key: "meterBase"
        }
      ],
      data2: []
    };
  }
};
</script>
